export default __webpack_public_path__ + "static/media/logo-gie-white.29c99888.svg";